import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getTechnicalReportById } from "../../actions/VehicleReplacementsActions";
import { useParams } from "react-router-dom";
import moment from "moment/moment";

function TechnicalReport() {
    const dispatch = useDispatch();
    const params = useParams();

    useEffect(() => {
        dispatch(getTechnicalReportById(params.id))
    }, [params.id])

    const technicalReport = useSelector(state => state?.vehicleReplacements?.technicalReport);

    return (
        <React.Fragment>
            <body className="bg-white w-full h-screen overflow-visible">
                <div className="intro-y bg-white pt-10">
                    <div className="bg-white container p-0">
                        <div className="text-center text-sm-start">
                            <div className="">
                                <img src="/images/logo.png" width={'100%'} height={100} alt="" />
                                <div className="text-center mt-5 text-decoration-underline fw-semibold fs-2xl">TECHNICAL REPORT</div>
                            </div>
                            <div className="fs-base container " style={{ display: 'flex', justifyContent: "space-between", paddingTop: '10px' }}>
                                <div className="" style={{ display: 'flex', flexDirection: 'column', justifyContent: "start" }}>
                                    <div className="mt-1 text-start"> To : <span className="fw-medium">Lease Plan Emirates L.L.C</span> </div>
                                    <div className="mt-1 text-start"> P.O Box : <span className="fw-medium">36679</span> </div>
                                    <div className="mt-1 text-start">Abu Dhabi, U.A.E </div>
                                    <div className="mt-1 text-start"> Phone : <span className="fw-medium">02-4046313</span> </div>
                                </div>
                                <div className="text-lg-end mt-10 mt-lg-0 ms-lg-auto">
                                    <div className="" style={{ display: 'flex', justifyContent: "end" }}>
                                        <div className="fs-base border border-gray-500 px-10">DATE</div>
                                        <div className="fs-base border border-gray-500 px-10">{moment(technicalReport?.created_at).format('YYYY-MM-DD')}</div>
                                    </div>
                                    <div className=" mt-5" style={{ display: 'flex', justifyContent: "end" }}>
                                        <div className="fs-base border border-gray-500 px-10">TR REF #</div>
                                        <div className="fs-base border border-gray-500 px-10">18027 07062022</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="py-5">
                            <div className="overflow-x-auto">
                                <table className="table table-bordered border-gray-500">
                                    <thead style={{ background: '#1c2076', color: '#fff' }}>
                                        <tr style={{ background: '#1c2076', color: '#fff' }}>
                                            <th style={{ padding: '5px' }} className="text-nowrap">REG. NO</th>
                                            <th style={{ padding: '5px' }} className="text-nowrap">VEHICLE MAKE</th>
                                            <th style={{ padding: '5px' }} className="text-nowrap">MODEL</th>
                                            <th style={{ padding: '5px' }} className="text-nowrap">KM</th>
                                            <th style={{ padding: '5px' }} className="text-nowrap">CHASIS NO.</th>
                                            <th style={{ padding: '5px' }} className="text-nowrap">PROGRAM DATE</th>
                                            <th style={{ padding: '5px' }} className="text-nowrap">OBJECT NO.</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td style={{ padding: '5px' }}>
                                                <div className="fw-medium text-nowrap">{technicalReport?.vehicle?.plate_number} - {technicalReport?.vehicle?.vehicle_code?.name} - {technicalReport?.vehicle?.state?.name}</div>
                                            </td>
                                            <td style={{ padding: '5px' }} className="fw-medium">{technicalReport?.vehicle?.vehicle_make?.name}</td>
                                            <td style={{ padding: '5px' }} className="fw-medium">{technicalReport?.vehicle?.vehicle_model?.name}</td>
                                            <td style={{ padding: '5px' }} className="fw-medium">{technicalReport?.vehicle?.service_mile}</td>
                                            <td style={{ padding: '5px' }} className="fw-medium">{technicalReport?.vehicle?.chasis_no}</td>
                                            <td style={{ padding: '5px' }} className="fw-medium">-</td>
                                            <td style={{ padding: '5px' }} className="fw-medium">{technicalReport?.id}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <table className="table table-bordered border-gray-500 mt-5">
                                <thead style={{ background: '#1c2076', color: '#fff' }}>
                                    <tr style={{ background: '#1c2076', color: '#fff' }}>
                                        <th style={{ padding: '5px' }} className="text-center fs-base text-uppercase">Problem Reported</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td style={{ padding: '5px' }} className="fw-medium fs-base px-5">{technicalReport?.problem}</td>
                                    </tr>
                                </tbody>
                            </table>
                            <table className="table table-bordered border-gray-500 mt-5">
                                <thead style={{ background: '#1c2076', color: '#fff' }}>
                                    <tr style={{ background: '#1c2076', color: '#fff' }}>
                                        <th style={{ padding: '5px' }} className="text-center fs-base text-uppercase">Observation</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td style={{ padding: '5px' }} className="fw-medium fs-base px-5">{technicalReport?.observation}</td>
                                    </tr>
                                </tbody>
                            </table>
                            <table className="table table-bordered border-gray-500 mt-5">
                                <thead style={{ background: '#1c2076', color: '#fff' }}>
                                    <tr style={{ background: '#1c2076', color: '#fff' }}>
                                        <th style={{ padding: '5px' }} className="text-center fs-base text-uppercase">Cause Of Damage</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td style={{ padding: '5px' }} className="fw-medium fs-base px-5">{technicalReport?.cause}</td>
                                    </tr>
                                </tbody>
                            </table>
                            <table className="table table-bordered border-gray-500 mt-5">
                                <thead style={{ background: '#1c2076', color: '#fff' }}>
                                    <tr style={{ background: '#1c2076', color: '#fff' }}>
                                        <th style={{ padding: '5px' }} className="text-center fs-base text-uppercase">Scope Of The Job</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td style={{ padding: '5px' }} className="fw-medium fs-base px-5">{technicalReport?.scope}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div className="px-5 pb-10">
                            <div className="text-center fs-sm mt-sm-0">
                                <div className="mt-1">NOTE: Although every care has been taken in compiling this report , it is possible that when dismantling further damages may be found. If so the cost
                                    may increase accordingly</div>
                            </div>
                        </div>
                        <div className="d-flex align-items-end justify-content-center" style={{ display: 'flex', alignItems: 'end', justifyContent: 'center' }}>
                            <div className="d-flex align-items-end justify-content-evenly" style={{ display: 'flex', alignItems: 'end', justifyContent: 'space-evenly' }} >
                                <div className="mt-2 px-1 fs-xs fw-medium"> Phone : <span className="">#1923195</span> </div>
                                <div className="mt-2 px-1 fs-xs fw-medium border-start border-gray-500"> P.O. Box : <span className="">33878 Sharjah, U.A.E</span> </div>
                                <div className="mt-2 px-1 fs-xs fw-medium border-start border-gray-500"> Mobile : <span className=""> 050- 8885608</span> </div>
                                <div className="mt-2 px-1 fs-xs fw-medium border-start border-gray-500"> Email : <span className=""> casc2020@hotmail.com, h_abutt@yahoo.com</span> </div>
                            </div>
                        </div>
                    </div>
                </div>
            </body>

        </React.Fragment >
    )
}

export default TechnicalReport;